import { render, staticRenderFns } from "./ques-checkbox.vue?vue&type=template&id=701d3315&scoped=true&"
import script from "./ques-checkbox.vue?vue&type=script&lang=js&"
export * from "./ques-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ques-checkbox.vue?vue&type=style&index=0&id=701d3315&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d3315",
  null
  
)

export default component.exports